<template>
    <v-select v-model="query.shows" v-bind="{ ...$attrs, items }" @change="emit" />
</template>

<script>
const items = [
    { text: "전체", value: null },
    { text: "사용자 노출", value: true },
    { text: "사용자 미노출", value: false },
];

const initQuery = (query = {}) => ({
    ...query,
    shows: JSON.parse(query.shows || "null"),
});

export default {
    data: () => ({
        items,
        query: initQuery(),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.$route.query;

            query.shows = this.query.shows;
            if (query.shows == null) delete query.shows;

            delete query.page;
            this.$router.push({ query });
        },
    },
};
</script>

<style></style>
